import t from '../common/localization'

export default {

  'live.location.share.enable': {
    name: t('attributeEnableLiveLocationSharing'),
    type: 'boolean',
  },
  'liveLocationBaseUrl': {
    name: t('attributeLiveLocationUrl'),
    type: 'string',
  },
  'gstmf': {
    name: t('attributeGstmf'),
    type: 'number',
  },
  'ui.disableReport': {
    name: t('attributeUiDisableReport'),
    type: 'boolean',
  },
  'ui.disableEvents': {
    name: t('attributeUiDisableEvents'),
    type: 'boolean',
  },
  'ui.disableDrivers': {
    name: t('attributeUiDisableDrivers'),
    type: 'boolean',
  },
  'ui.disableComputedAttributes': {
    name: t('attributeUiDisableComputedAttributes'),
    type: 'boolean',
  },
  'ui.disableCalendars': {
    name: t('attributeUiDisableCalendars'),
    type: 'boolean',
  },
  'ui.disableMaintenance': {
    name: t('attributeUiDisableMaintenance'),
    type: 'boolean',
  },
  'ui.hidePositionAttributes': {
    name: t('attributeUiHidePositionAttributes'),
    type: 'string',
  },
  'distanceUnit': {
    name: t('settingsDistanceUnit'),
    type: 'string',
  },
  'speedUnit': {
    name: t('settingsSpeedUnit'),
    type: 'string',
  },
  'volumeUnit': {
    name: t('settingsVolumeUnit'),
    type: 'string',
  },
  'timezone': {
    name: t('sharedTimezone'),
    type: 'timezone',
  },
  'mail.smtp.host': {
    name: t('attributeMailSmtpHost'),
    type: 'string',
  },
  'mail.smtp.port': {
    name: t('attributeMailSmtpPort'),
    type: 'string',
  },
  'mail.smtp.starttls.enable': {
    name: t('attributeMailSmtpStarttlsEnable'),
    type: 'string',
  },
  'mail.smtp.starttls.required': {
    name: t('attributeMailSmtpStarttlsRequired'),
    type: 'string',
  },
  'mail.smtp.ssl.enable': {
    name: t('attributeMailSmtpSslEnable'),
    type: 'string',
  },
  'mail.smtp.ssl.trust': {
    name: t('attributeMailSmtpSslTrust'),
    type: 'string',
  },
  'mail.smtp.ssl.protocols': {
    name: t('attributeMailSmtpSslProtocols'),
    type: 'string',
  },
  'mail.smtp.from': {
    name: t('attributeMailSmtpFrom'),
    type: 'string',
  },
  'mail.smtp.auth': {
    name: t('attributeMailSmtpAuth'),
    type: 'string',
  },
  'mail.smtp.username': {
    name: t('attributeMailSmtpUsername'),
    type: 'string',
  },
  'mail.smtp.password': {
    name: t('attributeMailSmtpPassword'),
    type: 'string',
  },
  'sms.http.url': {
    name: t('attributeSmsHttpUrl'),
    type: 'string',
  },
  'sms.http.authorizationHeader': {
    name: t('attributeSmsHttpAuthorizationHeader'),
    type: 'string',
  },
  'sms.http.authorization': {
    name: t('attributeSmsHttpAuthorization'),
    type: 'string',
  },
  'sms.http.user': {
    name: t('attributeSmsHttpUser'),
    type: 'string',
  },
  'sms.http.password': {
    name: t('attributeSmsHttpPassword'),
    type: 'string',
  },
  'sms.http.template': {
    name: t('attributeSmsHttpTemplate'),
    type: 'string',
  },
  'deviceInactiveTime': {
    name: t('attributeDeviceInactiveTime'),
    type: 'number',
  },
  'ui.deviceName': {
    name: t('attributeUiDeviceName'),
    type: 'boolean',
  },
  'ui.disableVehicleFeatures': {
    name: t('attributeUiDisableVehicleFeatures'),
    type: 'boolean',
  },
  'ui.trackingOnly': {
    name: t('attributeUiTrackingOnly'),
    type: 'boolean',
  },
  'ui.restrictDeviceDocuments': {
    name: t('attributeUiRestrictDeviceDocuments'),
    type: 'boolean',
  },
  'devHisDays': {
    name: t('attributeDevHisDays'),
    type: 'number',
  },
  'deviceCreateOnly': {
    name: t('attributeDeviceCreateOnly'),
    type: 'boolean',
  },
  'access.single': {
    name: t('attributeAccessSingle'),
    type: 'boolean',
  },
};
